<h3 class="text-center">Agent list</h3>
<div class="table-responsive" *ngIf="agents.length>0">
<table datatable [dtOptions]="dtOptions" class="table table-striped display compact" id="assetTable">
    <thead>
    <tr>
    <th>Date Created </th>
    <th>Names</th>
    <th>Coupon</th>
    
    <th>Enrolments</th>
    <th>Last Coupon Send Date</th> 
    <th>Send Coupon</th>
    <th>Coupon Send Count</th>
    </tr>
    </thead>
    
    <tbody>
    <tr *ngFor="let agent of agents;">
        <td>{{agent.datecreated}}</td>
        <td>{{agent.names}}</td>
        <td>{{agent.coupon}}</td>
        <td>
            <a [routerLink]="['/admin/couponEnrolment/agent']"
                [queryParams]="{agentId:agent.id}">
                {{agent.enrolmentCount}}
            </a>
        </td>
        <td>{{agent.lastCouponSendDate}}</td>
        <td><button  (click)="sendTheCoupon(agent.id)">Send Coupon</button></td>
        <td>{{agent.couponSendCount}}</td>
    </tr>
    </tbody>
     
</table>
</div>